module.exports = __webpack_public_path__ + "static/media/whatsapp.a2af4fff.svg";